import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { observable, autorun, action, toJS, map, extendObservable } from 'mobx';
import { observer } from 'mobx-react'

import {DictionaryTrans,autobind} from './DictionaryTrans';
import reactMixin  from 'react-mixin';
import ReactSortable  from 'react-sortablejs';
import Delete from './Delete';
import {IconArrow, IconTrash, IconEye, IconLayers,IconClone,IconLayerUp, IconLayerDonw, IconOpacity} from './Icons';
import Adjustment from './Adjustment';
import Settings from './Settings';

@observer
@reactMixin.decorate(DictionaryTrans)
@reactMixin.decorate(autobind(Object.keys(DictionaryTrans)))
export default class LayersBody extends Component {


  @observable trans = {};
  @observable data = [];
  isRemoveTip = observable.map({});
  @observable currentSelectedLayer = null;

  @observable showHideExpandPanel = [false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false];


  sortableConfig = {
    group: "name",  // or { name: "...", pull: [true, false, clone], put: [true, false, array] }
    sort: true,  // sorting inside list
    delay: 0, // time in milliseconds to define when the sorting should start
    disabled: false, // Disables the sortable if set to true.
    store: null,  // @see Store
    animation: 150,  // ms, animation speed moving items when sorting, `0` — without animation
    fallbackOnBody: false,  // Appends the cloned DOM Element into the Document's Body
    fallbackTolerance: 0, // Specify in pixels how far the mouse should move before it's considered as a drag.
    scroll: true, // or HTMLElement
    scrollSensitivity: 30, // px, how near the mouse must be to an edge to start scrolling.
    scrollSpeed: 10, // px
    handle : '.js-sortable-handle'
  };


  constructor(props) {

    super(props);

    this.trans = this.props.dictionaryStorage.getCurrentLangDict;

    let scope = this;


    $(window).on('bfLayers-addLayer',(e,data) => {
      if ( data != undefined )
      {

        data.showAdjustment = false;
        this.data.push(data);
      }

    })

    $(window).on('Layers-renderLayers',(e,data) => {
      //console.log('Layers-renderLayers-->',data.data);

      let tmp = data.data;
      _.map(data.data ,(v,k)=>{
        v.showAdjustment = false;
        v.hidden = false;
        v.hovered = false;

       if ( this.showHideExpandPanel[v.id] ) v.showAdjustment = this.showHideExpandPanel[v.id];
      })

      this.data = _.clone(tmp);

    })

    /*
    function isMobileDevice() {
      return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
    };
    if ( isMobileDevice() )
    {
      this.sortableConfig.handle = '.js-image, .js-title';
    }
    */

    this.selectLayer(Settings.getSettingsCurrentElementInstance.idLayer,true);


    $(window).on('Tools-deselectLayers',(e,obj)=>{

      this.deselectLayer();

    })

    $(window).on('WorkArea-selectCanvasElem',(e,active)=>{

      var idLayer = active.idLayer;
      this.selectLayer(idLayer,true);

    })

    $(window).on('WorkArea-deselectCanvasElem',(e,idLayer)=>{

      this.deselectLayer();
      //$('.js-bf-layers li').removeClass('active');

    })

    
    this.externalFunctions();

  }

  showHideLayer(d,key){
    d.hidden = !d.hidden;

    bfLayers.showHideLayer(d);
  }


  onChangeList(order,sortable){
    bfLayers.sort(order);
  }

  removeLayer(id)
  {
    bfLayers.removeLayerById(id);
  }

  showRemoveTip(id){
    this.isRemoveTip.set(id,true);
  }

  hideRemoveTip(id){
    this.isRemoveTip.set(id,false);
  }

  selectLayer(id,isExternalTrigger)
  {
    this.currentSelectedLayer = id;
    if ( id != - 1 && !isExternalTrigger ){

      $(window).trigger('CutCopyClone-doDeselectLayers');
      $(window).trigger('Layers-selectLayer',id);
    }
  }

  showAdjustment(d,key){
    let show = bfLayers.showHideAdjustment(d);
    this.showHideExpandPanel[d.id] = show;
  }

  deselectLayer(){
    this.currentSelectedLayer = -1;
  }

  clickLayerUp(d) {
    bfLayers.layerUp(d.id);
  }
  clickLayerDown(d) {
    bfLayers.layerDown(d.id);
  }
  clickClone(d){
    $(document).trigger("copy",d.id);
    setTimeout(()=> { $(document).trigger('paste'); },100);
  }


  render() {
    $('.LayersBody .iscroll-js').scrollbar();
    setTimeout(()=>{
      $('.LayersBody .iscroll-js').scrollbar();

    },500);
    const t = this.t;
    const data = bfLayers.currentLayers; //this.data;
    const isRemoveTip = toJS(this.isRemoveTip);

    return (
      <div className="LayersBody">

        <span className="prevent-container"></span>

          <div className="iscroll-js scrollbar-inner bf-layers-container babi">

            <ReactSortable
              className="bf-layers js-tools-on-off-content nano-content"
              tag="ul"
              options={this.sortableConfig}
              onChange={(order, sortable, evt) => {
                this.onChangeList(order,sortable);
              }}

            >
              {
                !this.props.toolbarMode
                &&
                _.map(data, (d, key) => {
                  return (
                    <li key={key} data-id={d.id} data-idImg={d.idImg} data-font={d.font}
                        onMouseEnter={ ()=> { d.hovered = true;  this.setState({}) } }
                        onMouseLeave={ ()=> { d.hovered = false; this.setState({}) } }
                        className={ (  d.showAdjustment && !d.font ) ? 'bf-layer-open ' : ''  + (this.currentSelectedLayer == d.id) ? 'active' : ''}>

                    <span
                      className={ (d.font ? 'font-layer' : '') + (this.currentSelectedLayer == d.id ? ' active' : '') }
                      data-id={d.id} data-idImg={d.idImg} data-font={d.font}>

                    <span className={"visibility js-visibility" + ( d.hidden ? 'off' : 'on' ) }>
                        <i onClick={ () => {
                          this.showHideLayer(d,key);
                        }} aria-hidden="true"><IconEye modeDisabled={d.hidden} active={( d.hovered || ( this.currentSelectedLayer == d.id) ? true : false)} /></i>
                    </span>

                      {
                        d.thumbCrop
                        &&
                        <span onClick={() => {
                          this.selectLayer(d.id)
                        }} className="img js-image js-sortable-handle"
                              style={{backgroundImage: "url(" + d.thumbCrop + ")"}}></span>
                      }
                      {
                        d.svg
                        &&
                        <span onClick={() => {
                          this.selectLayer(d.id)
                        }} className="img js-image js-sortable-handle"
                              style={{backgroundImage: "url(" + d.path + ")"}}></span>
                      }
                      {
                        ( !d.font && !d.thumbCrop && !d.svg )
                        &&
                        <span onClick={() => {
                          this.selectLayer(d.id)
                        }} className="img js-image js-sortable-handle"
                              style={{backgroundImage: "url(" + d.thumb + ")"}}></span>
                      }
                      {
                        d.font
                          ?
                          <span onClick={() => {
                            this.selectLayer(d.id)
                          }} style={{'fontFamily': d.font}}
                                className="title title-font js-title js-sortable-handle">{d.instance.text}</span>
                          :
                          <span onClick={() => {
                            this.selectLayer(d.id)
                          }} className="title js-title js-sortable-handle">{d.originalName}</span>
                      }

                      {
                        !d.font
                        &&
                        <span onClick={ () => {
                          this.showAdjustment(d,key)
                        } } className="show-adjustment"><IconArrow  modeDisabled={( d.showAdjustment  ? true : false)} active={( d.hovered || ( this.currentSelectedLayer == d.id) ? true : false)} size="small"/></span>
                      }

                      <span onClick={ () => {
                        this.showRemoveTip(d.id)
                      } } className="remove"><IconTrash size="small" active={( d.hovered || ( this.currentSelectedLayer == d.id) ? true : false)}  /></span>
                      {
                        isRemoveTip[d.id]
                        &&
                        <Delete
                          dictionaryStorage={this.props.dictionaryStorage}
                          dingsPosition="right"
                          onDelete={ () => {
                            this.removeLayer(d.id)
                          } }
                          onCancel={ () => {
                            this.hideRemoveTip(d.id)
                          } }
                        />

                      }

                      { (  !d.font && !d.svg && ( d.quality == "low" || d.quality == "very-low" ) )
                      &&
                      <span
                        className={"js-bad-quality bad-quality " + d.quality}>
                        <i className="fa fa-exclamation-triangle">
                          {
                            ( d.quality == "low" )
                            &&
                            <span>{t('Low quailty')}</span>
                          }
                          {
                            ( d.quality == "very-low" )
                            &&
                            <span>{t('Low low quailty')}</span>
                          }

                        </i>
                      </span>
                      }
                    </span>
                      {
                        (   d.showAdjustment && !d.font )
                        &&
                        <div className="bf-adjustment  js-tools-on-off-content ">
                          <Adjustment
                            idLayer={d.id}
                            layer={d}
                            dictionaryStorage={this.props.dictionaryStorage}
                            show={['opacity', 'brightness', 'contrast', 'saturate', 'stackblur']}
                            showReset={true}
                            showIconWithText={true}
                          />
                        </div>
                      }


                    </li>
                  )
                })

              }

              {
                  this.props.toolbarMode
                  &&
                  _.map(data, (d, key) => {
                  return(
                  <li key={key}   data-id={d.id} data-idImg={d.idImg} data-font={d.font} className={ (  d.showAdjustment && !d.font ) ? 'bf-layer-open ' : ''  + (this.currentSelectedLayer == d.id ? ' active' : '')}>
                  <span  className={ (d.font ? 'font-layer' : '')  + (this.currentSelectedLayer == d.id ? ' active' : '') }   data-id={d.id} data-idImg={d.idImg} data-font={d.font} >


                  {
                    d.thumbCrop
                    &&
                    <span onClick={()=>{this.selectLayer(d.id)}} className="img js-image js-sortable-handle" style={{backgroundImage:"url(" + d.thumbCrop + ")"}}></span>
                  }
                  {
                    d.svg
                    &&
                    <span onClick={()=>{this.selectLayer(d.id)}} className="img js-image js-sortable-handle" style={{backgroundImage:"url(" + d.path + ")"}}></span>
                  }
                  {
                    ( !d.font && !d.thumbCrop && !d.svg )
                    &&
                    <span onClick={()=>{this.selectLayer(d.id)}} className="img js-image js-sortable-handle" style={{backgroundImage:"url(" + d.thumb + ")"}}></span>
                  }
                  {
                    d.font
                      ?
                      <span onClick={()=>{this.selectLayer(d.id)}} style={{'fontFamily': d.font}} className="title title-font js-title js-sortable-handle">{d.instance.text}</span>
                      :
                      <span onClick={()=>{this.selectLayer(d.id)}} className="title js-title js-sortable-handle">{d.originalName}</span>
                  }

                  {

                    <span onClick={ ()=> { this.showAdjustment(d,key) } } className="show-adjustment"><IconArrow modeDisabled={( d.showAdjustment ? true : false)} active={(this.currentSelectedLayer == d.id)} size="small" /></span>
                  }



                  { (  !d.font && !d.svg && ( d.quality == "low" || d.quality == "very-low" ) )
                  &&
                  <span
                    className={"js-bad-quality bad-quality " + d.quality}>
                            <i className="fa fa-exclamation-triangle">
                              {
                                ( d.quality == "low" )
                                &&
                                <span>{t('Low quailty')}</span>
                              }
                              {
                                ( d.quality == "very-low" )
                                &&
                                <span>{t('Low low quailty')}</span>
                              }

                            </i>
                          </span>
                  }
                  </span>
                  {
                    (   d.showAdjustment  )
                    &&
                    <div className="LayersExtend">
                      <div className="LayersExtendPanel">
                        <button className={"visibility " +( d.hidden ? 'off' : 'on' ) } >
                          <i onClick={ ()=> { this.showHideLayer(d); }} aria-hidden="true"><IconEye modeDisabled={d.hidden} /></i>
                        </button>

                        <button onClick={ ()=> { this.clickLayerUp(d) } }><IconLayerUp/></button>
                        <button onClick={ ()=> { this.clickLayerDown(d) } }><IconLayerDonw/></button>
                        <button onClick={ ()=> { this.clickClone(d) } }><IconClone/></button>
                        <div className="CanvaTool-buttonContainer">
                          <button onClick={ () => {  this.showRemoveTip(d.id)  } }><IconTrash/></button>
                          {
                            isRemoveTip[d.id]
                            &&
                            <Delete
                              dictionaryStorage={this.props.dictionaryStorage}
                              dingsPosition="right"
                              onDelete={ () => {
                                this.removeLayer(d.id)
                              } }
                              onCancel={ () => {
                                this.hideRemoveTip(d.id)
                              } }
                            />

                          }
                        </div>
                      </div>
                      <div className="LayersExtendAdjustment">
                        <IconOpacity/>
                        <Adjustment
                          idLayer={d.id}
                          layer={d}
                          dictionaryStorage={this.props.dictionaryStorage}
                          show={['opacity']}
                          showReset={false}
                          showIconWithText={false}
                        />
                      </div>
                    </div>
                  }


                  </li>
                  )
                })
            }

          </ReactSortable>

        </div>
      </div>
    );
  }

  externalFunctions(t){

    let scope = this;

    /*
    $(window).on('MediaManager-removeImage',function(e,obj){

      // find image on layer and remove
      //todo: check if it is needed

      var layer_id = bfLayers.getLayerByIdImg(obj.id);

      if ( bfLayers.getCurrentViewTable(layer_id) !== undefined )
      {
        $(window).trigger('bf-transform',{'action':'remove','idLayer':bfLayers.getCurrentViewTableId(layer_id)});

        bfLayers.removeLayerById(bfLayers.getCurrentViewTableId(layer_id));
        bfCreateLayers();
      }

    })
    */

    $(document).ready(function(){

      /*

      $(window).on('MediaManager-addLayer',function(e,obj){



        var obj2 = _.clone(obj);addLayerToCanva
        obj2.idImg = obj.id;


        var layer = bfLayers.prepareLayer(obj2);

        $(window).trigger('Layers-addLayerToCanvas',layer);
          console.log('tr Layers-addLayerToCanva');
      })

     $(window).on('WorkArea-layer-added',function(e,obj){
        console.log('on WorkArea-layer-added');
        var layer = bfLayers.addLayer(obj);
        bfCreateLayers();

      });

      $(window).on('WorkArea-addLayerFromData CCC-addLayerFromData',function(e,obj){
        console.log('WorkArea-addLayerFromData CCC-addLayerFromDat');
        bfLayers.addLayer(obj);
        bfCreateLayers();

      })
*/

      $(window).on('WorkArea-addLayersFromDataEnd',function(e,obj){

      })

      /*
      $(window).on('Layers-removeLayer',function(e,id){

        //bfLayers.push(obj);
        bfLayers.removeLayerById(id);

        bfCreateLayers();
        $(window).trigger('bf-transform',{'action':'remove','idLayer':id});
      })
      */

      var notifyQualityTimer = null;
      function testQuality(obj){

        if (  obj.prevQuality == obj.quality || ( obj.prevQuality == undefined && obj.quality == 'good' )  )
        {
          return;
        }
        $(".notifyjs-wrapper").click();
        if ( obj.quality == 'low' )
        {
          var obj_notify = new Object();
          obj_notify.title = 'Warning';
          obj_notify.text = 'Oh oh. The current image has a low quality.';
          obj_notify.type = 'warning';
          $(window).trigger('notify',obj_notify);

        }
        if ( obj.quality == 'very-low' )
        {
          var obj_notify = new Object();
          obj_notify.title = 'Warning';
          obj_notify.text = 'Ups. The current image has a very low quality. Please choose another one.';
          obj_notify.type = 'error';
          $(window).trigger('notify',obj_notify);
        }

        if ( obj.prevQuality !== 'good' && obj.quality == 'good' )
        {
          var obj_notify = new Object();
          obj_notify.title = 'Success';
          obj_notify.text = 'Yeah, nice! The picture has a perfect quality.';
          obj_notify.type = 'success';
          $(window).trigger('notify',obj_notify);
        }

      }

     // var canvasElemScalingTimer = null;


      $(document).on('click','.js-remove-layer',function(){

        var id = $(this).closest('li').attr('data-id');
        $(window).trigger('Layers-removeLayer',id);

      })


    })

    $(window).on('Crop-setCropToActiveLayer',function(e,obj){

      let id = scope.currentSelectedLayer;
      bfLayers.getLayerById(id).thumbCrop = obj.thumbUrl;
      bfLayers.getLayerById(id).urlCrop = obj.url;
      $(window).trigger('renderLayers');

    })

    $(window).on('renderLayers',function(){

      var id = $('.js-bf-layers li.active').attr('data-id');
      bfCreateLayers(id);

    })

    function bfCreateLayers(id){

      if ( bf_config.mode == 'phantom' ) return;


      let objLayers = {
        data : bfLayers.getData()
      }

      $(window).trigger('Layers-renderLayers',objLayers);

      //$(window).trigger('bfLayers-addLayer',bfLayers.getData());

    }

    $(window).on('WorkArea-textChangeCanvasElem',function(e,active){
      $(window).trigger('renderLayers');
    })
  }

}






